import { render } from "./Negociacoes.vue?vue&type=template&id=74f8e6d0&scoped=true"
import script from "./Negociacoes.vue?vue&type=script&lang=js"
export * from "./Negociacoes.vue?vue&type=script&lang=js"

import "./Negociacoes.vue?vue&type=style&index=0&id=74f8e6d0&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f8e6d0"]])

export default __exports__